import { registerCapability } from '../../platform/capability-registry';
import { NetworkBlock } from './NetworkBlock';
import { NETWORK_FIELD_KEY_LIST } from './fieldKeys';
import { resolveNetworkPaths } from './resolvePaths';
import type { NetworkBlockOptions } from './types';

registerCapability<NetworkBlockOptions>({
  key: 'network',
  fields: [...NETWORK_FIELD_KEY_LIST],
  component: NetworkBlock,
  defaultPaths: (prefix) => resolveNetworkPaths(prefix),
  resolvePaths: (prefix, options) => resolveNetworkPaths(prefix, options),
});
